import type { PartnerProductFormatted } from '~/entities/partner-product'
import type { ViewRow } from '../../model/components/index.h'

import { CardCorners } from "/app/libraries/arcana/src/blocks/Cards/index.ts"
import { PartnerProgramCard } from "/app/libraries/arcana/src/blocks/Cards/PartnerProgramCard/index.ts"

import { useMemo } from 'react'
import { isPaid } from '~/features/payment'
import { addQuery } from '~/shared/routes'
import { getCardFonts } from '../lib/style'

export const PartnerCard = ({
  item,
  row,
}: {
  item: PartnerProductFormatted
  row: ViewRow
}) => {
  const { coverImageUrl, rented, name, id, labelPrice } = item

  const {
    appearance: {
      style: { posterSize },
      title,
    },
  } = row

  const { titleFont } = getCardFonts(posterSize)

  const link = useMemo(
    () => addQuery(`/partner-program/${id}`, { categoryName: title }),
    [id, title]
  )

  return (
    <a href={link}>
      <PartnerProgramCard
        corners={CardCorners.CORNERS_25}
        posterUrl={coverImageUrl}
        paid={isPaid(item)}
        description={name}
        purchaseTitle={labelPrice}
        rented={rented}
        descriptionFont={titleFont}
      />
    </a>
  )
}
